export default "__VITE_ASSET__BgE3YCpG__"